module.exports = __webpack_public_path__ + "cement/img/组 4206.c9423746.png";